import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import Select from "react-select"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import Spinners from "components/Common/Spinner"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// actions
import { loginUser, socialLogin } from "../../store/actions"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { postLogin } from "helpers/fakebackend_helper"
import { toast } from "react-toastify"
import axios from "axios"
import { HandleException } from "helpers/api_helper"

const Login = props => {
  //meta title
  document.title = "Login | TN-School"

  const [isLoading, setIsLoading] = useState(false)
  const [isPageLoading, setIsPageLoading] = useState(false)

  const userType1 = [ 
    {label: '1', value: '1'}, 
    {label: '2', value: '2'}, 
    {label: '3', value: '3'}, 
    {label: '4', value: '4'}, 
    {label: '5', value: '5'}, 
    {label: '6', value: '6'}, 
    {label: '7', value: '7'}, 
    {label: '8', value: '8'}, 
    {label: '9', value: '9'}, 
    {label: '10', value: '10'}, 
    {label: '14', value: '14'}, 
    {label: '16', value: '16'}, 
    {label: '17', value: '17'}, 
    {label: '18', value: '18'}, 
    {label: '19', value: '19'}, 
    {label: '20', value: '20'}, 
    {label: '21', value: '21'}, 
    {label: '11', value: '11'}, 
    {label: '22', value: '22'}, 
    {label: '23', value: '23'}, 
    {label: '15', value: '15'}, 
    {label: '24', value: '24'}, 
    {label: '30', value: '30'}, 
    {label: '25', value: '25'}, 
    {label: '26', value: '26'}, 
    {label: '27', value: '27'}, 
    {label: '31', value: '31'}, 
    {label: '32', value: '32'}, 
    {label: '33', value: '33'}, 
    {label: '34', value: '34'}, 
    {label: '35', value: '35'}, 
    {label: '37', value: '37'}, 
    {label: '38', value: '38'}, 
    {label: '39', value: '39'}, 
    {label: '13', value: '13'}, 
    {label: '40', value: '40'}, 
    {label: '41', value: '41'}, 
    {label: '42', value: '42'}, 
    {label: '43', value: '43'}, 
    {label: '44', value: '44'}, 
    {label: '50', value: '50'}, 
    {label: '51', value: '51'}, 
    {label: '52', value: '52'}, 
    {label: '0', value: '0'}, 
    {label: '53', value: '53'}, 
    {label: '54', value: '54'}, 
    {label: '56', value: '56'}, 
    {label: '58', value: '58'}, 
    {label: ',1597', value: ',1597'}, 
    {label: '55', value: '55'}, 
    {label: '59', value: '59'}, 
    {label: '61', value: '61'}, 
    {label: '62', value: '62'}, 
    {label: '63', value: '63'}, 
    {label: '65', value: '65'}, 
    {label: '66', value: '66'}, 
    {label: '36', value: '36'}, 
    {label: '67', value: '67'},
    {label: '68', value: '68'},
    {label: '64', value: '64'},
    {label: '69', value: '69'},
    {label: '70', value: '70'},
    {label: '71', value: '71'},
    {label: '72', value: '72'}, 
    {label: '73', value: '73'}, 
    {label: '74', value: '74'}, 
    {label: '75', value: '75'}, 
    {label: '76', value: '76'}, 
    {label: '78', value: '78'}, 
    {label: '80', value: '80'}, 
    {label: '79', value: '79'},   
      ]
    
  const userType2 = [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
    { label: "32", value: "32" },
    { label: "33", value: "33" },
    { label: "34", value: "34" },
    { label: "35", value: "35" },
    { label: "36", value: "36" },
    { label: "37", value: "37" },
    { label: "38", value: "38" },
    { label: "39", value: "39" },
    { label: "40", value: "40" },
    { label: "41", value: "41" },
    { label: "42", value: "42" },
    { label: "43", value: "43" },
    { label: "44", value: "44" },
    { label: "45", value: "45" },
    { label: "51", value: "51" },
    { label: "71", value: "71" },
    { label: "91", value: "91" },
    { label: "92", value: "92" },
    { label: "93", value: "93" },
    { label: "121", value: "121" },
    { label: "122", value: "122" },
    { label: "123", value: "123" },
    { label: "124", value: "124" },
    { label: "125", value: "125" },
    { label: "126", value: "126" }
  ];

  const router = useNavigate()
  const location = useLocation()
  const query = new URLSearchParams(location.search);

const parseArray = (phpString) => {
  const jsonObject = {};  

  const matches = phpString.match(/\[\s*([\w\d_]+)\s*\] => (.*)/g);
  if (!matches) return jsonObject;

  matches.forEach((match) => {
    const [_, key, value] = match.match(/\[\s*([\w\d_]+)\s*\] => (.*)/) || [];

    if (key) {
      jsonObject[key] = value.trim() === "" ? null : value.trim();
    }
  });

  return jsonObject;
};
  
  const handleAuthLogin = async (token) => {
    try {
      const body = {
        "EMIS": query.get('emis'),
 	      "mobile_no": query.get('phone')
      }
      // production
      // const response = await axios.post('https://tnega.tnschools.gov.in/tnega/api/sso_login',body,{headers:{Authorization:token}});
     
      //  Staging 
      const response = await axios.post('https://tng2c2.tnschools.gov.in/tnega/tnega/api/sso_login',body,{headers:{Authorization:token}});
     
      const jsonValue = typeof response.data == 'object' ? response.data?.data : parseArray(response.data);
      if(jsonValue){
        const body2 = {
          user_type1: jsonValue?.emis_usertype ?? '',
          user_type2: jsonValue?.emis_usertype1 ?? '',
        }
        handleLogin(body2)
      }else {
        toast.error("unauthorized token")
        router('/pages-401')
      }
    } catch (error) {
      setIsPageLoading(false);
      console.log('err', error);
    }
  }

  const handleToken = async () =>  {
    try {
      setIsPageLoading(true);
      const response = await axios.get('https://tnega.tnschools.gov.in/tnega/api/authKey');
      if(response.data?.status == 200){
        const token = response.data?.Authorization_key; 
        handleAuthLogin(token);
      }else {
        toast.error("unauthorized token!")
        setIsPageLoading(false);
        router('/pages-401')
      }
    } catch (error) {
      console.log('err', error);
      HandleException(error)
      setIsPageLoading(false);
    }
  }


  useEffect(() => {
    if(query.get('emis') && query.get('phone')){
      handleToken();
    }
  },[location])
  
  const dispatch = useDispatch()

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // email: "scert" || '',
      // password: "test@123" || '',
      email: "",
      password: "",
      user_type1: "",
      user_type2: "",
      auth: "",
    },
    validationSchema: Yup.object({
      // email: Yup.string().required("Please Enter Your Email"),
      // password: Yup.string().required("Please Enter Your Password"),
      user_type1: Yup.string(),
      user_type2: Yup.string(),
    }),
    onSubmit: (values, { setErrors, setFieldError }) => {
      // dispatch(loginUser(values, props.router.navigate));
      // if(values.email == 'scert' && values.password == 'test@123') {
      //   localStorage.setItem("authUser", JSON.stringify({
      //     uid: 1,
      //     username: "admin",
      //     role: "admin",
      //     password: "test@123",
      //     email: "scert",
      //   }));
      //   router('/class');
      // }else {
      //   setFieldError('auth', "Username and password are invalid. Please enter correct username and password")
      // }

      if(!values.user_type1 || ! values.user_type2 ){
        return toast.error('Select User Type!')
      }

      const body = {
        user_type1: values.user_type1,
        user_type2: values.user_type2,
      }
      
      handleLogin(body)
    },
  })

  const handleLogin = payload => {
    setIsLoading(true)
    postLogin(payload)
      .then(res => {
        if(res.access){
          localStorage.setItem("authUser", JSON.stringify(res))
          localStorage.setItem("token", res.access)
          setIsLoading(false)
          setIsPageLoading(false);
          router("/dash-board")
        }else {
          toast.error("unauthorized token!");
          router('/pages-401')
        }
      })
      .catch(err => {
        console.log("err", err);
        router('/pages-401')
        setIsPageLoading(false);
        validation.setFieldError(
          "auth",
          err?.response?.data?.error ?? err.message
        )
        setIsLoading(false)
      })
  }

  const LoginProperties = createSelector(
    state => state.Login,
    login => ({
      error: login.error,
    })
  )

  const { error } = useSelector(LoginProperties)

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate))
  }

  //for facebook and google authentication
  const socialResponse = type => {
    signIn(type)
  }

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center"> 
            {
              isPageLoading ?
              <Spinners setLoading={setIsPageLoading} /> :
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary-subtle">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4"
                        // role="button" 
                        // onClick={()=> {
                        //   router({pathname:"/login", search:'?emis=4028606&phone=9100799886'})
                        // }}
                        >
                          <h5 className="text-primary">Welcome Back !</h5>
                          <p>Sign in to continue</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/" className="logo-light-element">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          return false
                        }}
                      >
                        {validation.errors.auth ? (
                          <Alert color="danger">{validation.errors.auth}</Alert>
                        ) : null}

                        <div className="mb-3">
                          <Label>Select user Type 1</Label>
                          <Select
                            placeholder="Select user Type 1"
                            options={userType1}
                            getOptionLabel={e => e?.label}
                            getOptionValue={e => e?.value}
                            value={userType1?.find(
                              e =>
                                e?.value ==
                              validation.getFieldProps("user_type1").value
                            )}
                            onChange={e => {
                              validation.setFieldValue("user_type1", e?.value)
                            }}
                            className="select2-selection"
                          />
                          {validation.touched.user_type1 &&
                          validation.errors.user_type1 ? (
                            <p className="mb-0 text-danger mt-1">
                              {validation.errors.user_type1}
                            </p>
                          ) : null}
                        </div>

                        <div className="mb-3">
                            <Label>Select user Type 2</Label>
                            <Select
                              placeholder="Select user Type 2"
                              options={userType2}
                              getOptionLabel={e => e?.label}
                              getOptionValue={e => e?.value}
                              value={userType2?.find(
                                e =>
                                  e?.value ==
                                  validation.getFieldProps("user_type2").value
                              )}
                              onChange={e => {
                                validation.setFieldValue("user_type2", e?.value
                                )
                              }}
                              className="select2-selection"
                            />
                            {validation.touched.user_type2 &&
                            validation.errors.user_type2 ? (
                              <p className="mb-0 text-danger mt-1">
                                {validation.errors.user_type2}
                              </p>
                            ) : null}
                          </div>

                        {/* <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div> */}
                        {/* <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div> */}

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <>
                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                Loading
                              </>
                            ) : (
                              "Log In"
                            )}
                          </button>
                        </div>

                        {/* <div className="mt-4 text-center">
                          <h5 className="font-size-14 mb-3">Sign in with</h5>

                          <ul className="list-inline">
                            <li className="list-inline-item">
                              <Link
                                to="#"
                                className="social-list-item bg-primary text-white border-primary"
                                onClick={e => {
                                  e.preventDefault();
                                  socialResponse("facebook");
                                }}
                              >
                                <i className="mdi mdi-facebook" />
                              </Link>
                            </li>
                      
                            <li className="list-inline-item">
                              <Link
                                to="#"
                                className="social-list-item bg-danger text-white border-danger"
                                onClick={e => {
                                  e.preventDefault();
                                  socialResponse("google");
                                }}
                              >
                                <i className="mdi mdi-google" />
                              </Link>
                            </li>
                          </ul>
                        </div> */}

                        <div className="mt-4 text-center">
                          <Link to="/forgot-password" className="text-muted">
                            <i className="mdi mdi-lock me-1" />
                            Forgot your password?
                          </Link>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  {/* <p>
                    Don&#39;t have an account ?{" "} <Link to="/register" className="fw-medium text-primary">
                      {" "}
                      Signup now{" "}
                    </Link>{" "}
                  </p> */}
                  <p>
                    © {new Date().getFullYear()} TN SCHOOL.
                    {/* Crafted with{" "}
                    <i className="mdi mdi-heart text-danger" /> by Themesbrand */}
                  </p>
                </div>
              </Col>
            }
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
